import './JobTime.css';
import React from "react";
import {Bar} from "react-chartjs-2";
  
const styles = {
  height:'600px',
  width: '600px'
}

/**
 * Fields()
 * This function is used to export a bar graph 
 * based on Job timings.
 * param {*} props 
 * returns Bar Component
 */
function Fields(props) {
  const options = {
    legend: {
      align: "bottom",
      display: true,
      position: "bottom",
      labels: {
        fontColor: "#fff",
        fontSize: 28
      }
    },
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
        },
      ],
    },
    tooltips: {
      mode: "label",
    },
    responsive: true,
    maintainAspectRatio: false,
  };
  const legend = {
    display: true,
    position: "bottom",
    labels: {
      fontColor: "#323130",
      fontSize: 28,
    },
}

  /**
   * displayJobTime()
   * This function receives Job type data from app.js,
   * using props, saves data as state and count of part time
   * jobs and full time jobs, and displays in Bar graph
   * returns Bar Graph
   */
  const displayJobTime = () => {
    if(props.jobTypeData) {
      let stateData = props.jobTypeData
      
      const stateName=[]
      const FTcount=[]
      const PTcount=[]
      for(let i=0; i<stateData.length; i++){
        stateName.push(stateData[i].state)
        FTcount.push(stateData[i].FullTime)
        PTcount.push(stateData[i].PartTime)
      }
      const data = {
          labels: stateName,
          datasets: [
            {
              label: "Full Time",
              data: FTcount,
              fill: false,
              backgroundColor: "magenta",
              borderColor: "red",
              
            },
            {
              label: "Part Time",
              data: PTcount,
              fill: false,
              backgroundColor: "green",
              borderColor: "pink",
              
            }
          ]
      }
      return(<div><Bar  className="PartFullDiv" data={data} options={options} legend={legend} width={500} height={500}
      ></Bar></div>)
    }
  }

  return (
    <div class = "col-md-6" style = {styles}>
      {displayJobTime()}
    </div>
  );
}
export default Fields;